var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardMagellanLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 294,
    height: 41,
    viewBox: "0 0 294 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8516 31.528L54.871 38.4289L51.8903 31.528H50.129V39.6468H51.0774V32.0692H51.2129L54.4645 39.6468H55.2774L58.529 32.0692H58.6645V39.6468H59.6129V31.528H57.8516Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4387 39.6468H65.9806V31.528H65.4387V39.6468Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2452 30.8517H71.4V38.9705H74.2452C77.3613 38.9705 78.5806 37.0761 78.5806 34.9111C78.5806 32.7461 77.3613 30.8517 74.2452 30.8517ZM74.2452 38.429H72.3484V31.5281H74.2452C76.4129 31.5281 77.6323 32.7459 77.6323 34.9109C77.6323 37.2112 76.4129 38.429 74.2452 38.429Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7806 36.8053C83.1871 38.0231 84 38.5644 85.6258 38.5644C86.8452 38.5644 87.6581 37.8878 87.6581 36.9406C87.6581 34.7756 82.2387 35.5875 82.2387 32.8812C82.2387 31.6634 83.3226 30.7162 85.0839 30.7162C86.7097 30.7162 87.7935 31.3928 88.3355 32.6106L87.5226 32.8812C87.1161 31.934 86.4387 31.3928 85.0839 31.3928C84 31.3928 83.1871 31.934 83.1871 32.8812C83.1871 33.4225 83.3226 33.8284 85.2194 34.3697C88.0645 35.1815 88.6065 35.7228 88.6065 36.9406C88.6065 38.2937 87.1161 39.1056 85.6258 39.1056C83.5935 39.1056 82.5097 38.4291 81.9677 36.9406L82.7806 36.8053Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4839 31.528V32.0692H96.4645V39.6468H97.2774V32.0692H100.258V31.528H93.4839Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.148 39.6468H111.097L108.794 35.7227C110.148 35.452 110.826 34.7755 110.826 33.693C110.826 32.3398 109.606 31.528 107.71 31.528H104.323V39.6468H105.271V35.9933H107.845L110.148 39.6468ZM107.71 35.3174H105.271V32.0699H107.71C109.2 32.0699 109.877 32.7465 109.877 33.6937C109.877 34.7762 109.065 35.3174 107.71 35.3174Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.516 31.528V39.6468H121.935V39.1055H117.329V35.7227H120.445V35.1814H117.329V32.0692H121.665V31.528H116.516Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.645 39.6468L128.032 31.528H129.523L132.774 39.6468H131.69L130.606 36.9405H126.677L125.594 39.6468H124.645ZM130.471 36.2646L128.71 32.0699L126.948 36.2646H130.471Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.561 31.528L141.581 38.4289L138.6 31.528H136.839V39.6468H137.787V32.0692H137.923L141.174 39.6468H141.987L145.239 32.0692H145.374V39.6468H146.323V31.528H144.561Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.161 31.528V39.6468H158.245V36.1286H160.413C162.852 36.1286 163.935 35.1814 163.935 33.8283C163.935 32.4751 162.987 31.528 160.413 31.528H157.161ZM160.277 35.4529H158.11V32.2054H160.277C162.039 32.2054 162.852 32.7466 162.852 33.8291C162.852 34.9116 162.174 35.4529 160.277 35.4529Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.645 39.6468L170.032 31.528H171.387L174.639 39.6468H173.69L172.606 36.9405H168.677L167.594 39.6468H166.645ZM172.471 36.2646L170.71 32.0699L168.948 36.2646H172.471Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.665 39.6468H185.613L183.31 35.7227C184.665 35.452 185.342 34.7755 185.342 33.693C185.342 32.3398 184.123 31.528 182.226 31.528H178.839V39.6468H179.787V35.9933H182.361L184.665 39.6468ZM182.226 35.3174H179.787V32.0699H182.226C183.716 32.0699 184.394 32.7465 184.394 33.6937C184.394 34.7762 183.581 35.3174 182.226 35.3174Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.677 31.528V32.0692H192.658V39.6468H193.471V32.0692H196.452V31.528H189.677Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.477 31.528V38.2936H206.342L202.006 31.528H200.516V39.6468H201.329V32.0692H201.465L206.342 39.6468H207.29V31.528H206.477Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.065 31.528V39.6468H219.484V39.1055H214.877V35.7227H217.994V35.1814H214.877V32.0692H219.213V31.528H214.065Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.645 38.9705H230.729L228.29 35.1817C229.645 34.9111 230.323 34.2345 230.323 33.152C230.323 31.7989 229.239 30.8517 227.206 30.8517H223.955V38.9705H224.903V35.317H227.477L229.645 38.9705ZM227.342 34.6403H224.903V31.5281H227.342C228.697 31.5281 229.51 31.934 229.51 33.0165C229.51 34.099 228.697 34.6403 227.342 34.6403Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.2 36.8053C235.606 38.0231 236.419 38.5644 238.045 38.5644C239.265 38.5644 239.942 37.8878 239.942 36.9406C239.942 34.7756 234.658 35.5875 234.658 32.8812C234.658 31.6634 235.606 30.7162 237.503 30.7162C238.994 30.7162 240.213 31.3928 240.619 32.6106L239.806 32.8812C239.4 31.934 238.723 31.3928 237.503 31.3928C236.284 31.3928 235.606 31.934 235.606 32.8812C235.606 33.4225 235.742 33.8284 237.639 34.3697C240.348 35.1815 240.89 35.7228 240.89 36.9406C240.89 38.2937 239.535 39.1056 237.91 39.1056C236.013 39.1056 234.929 38.4291 234.387 36.9406L235.2 36.8053Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.632 38.2938V39.3763H245.903L245.361 41.0001H245.768L246.445 39.3763V38.2938H245.632Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.774 31.528V39.6468H264.194V39.1055H259.723V31.528H258.774Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.529 39.241H269.342V38.6998H268.529V39.241Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.677 31.528V39.6468H274.761V36.1286H276.929C279.368 36.1286 280.452 35.1814 280.452 33.8283C280.452 32.4751 279.503 31.528 276.929 31.528H273.677ZM276.794 35.4529H274.626V32.2054H276.794C278.555 32.2054 279.368 32.7466 279.368 33.8291C279.368 34.9116 278.69 35.4529 276.794 35.4529Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.432 39.241H284.245V38.6998H283.432V39.241Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4839 0.406494V26.1161H56.9032V6.22498L64.4903 26.1161H71.129L78.4452 6.63092V26.1161H84V0.541808H75.0581L67.7419 20.8388L60.1548 0.406494H51.4839Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.781 0.406494H97.4129L86.7097 26.1161H93.2129L95.6516 20.2976H106.49L108.658 26.1161H115.161L103.781 0.406494ZM104.323 15.8317H97.4129L100.8 6.90098L104.323 15.8317Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.329 13.1254C117.329 6.35974 122.071 0 128.981 0H145.239V4.73597H130.471C126.406 4.73597 124.239 9.06601 124.239 12.9901C124.103 17.0495 126.271 21.6502 130.335 21.6502H139.142V15.1551H130.065V10.8251H145.374V26.1155H128.032C121.394 26.1155 117.329 19.6205 117.329 13.1254Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.723 24.6272C146.594 20.7032 146.594 5.68335 154.723 1.48863C157.026 0.406125 158.652 0.135498 161.226 0.135498H173.148V4.73616H162.174C160.277 4.73616 159.058 5.1421 157.703 6.49523C156.484 7.84837 155.942 9.06619 156.077 10.9606H173.284V15.5612H155.942C155.942 17.185 156.348 18.4028 157.432 19.4853C158.516 20.8385 159.735 21.515 161.497 21.515H173.013V25.9804H160.277C158.11 25.9804 156.755 25.5744 154.723 24.6272Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.445 16.7791C183.445 18.2675 183.716 19.2147 184.665 20.2972C186.019 21.921 187.781 22.1916 189.948 22.1916H198.348V26.3863H188.865C183.987 26.3863 179.652 25.5744 177.619 21.3797C176.942 19.756 176.671 18.6735 176.671 16.9144V0.135498H183.445V16.7791Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.239 16.7791C208.239 18.2675 208.51 19.2147 209.458 20.2972C210.813 21.921 212.574 22.1916 214.742 22.1916H223.142V26.3863H213.658C208.781 26.3863 204.445 25.5744 202.413 21.3797C201.735 19.756 201.465 18.6735 201.465 16.9144V0.135498H208.239V16.7791Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.974 0.406494H235.606L224.903 26.1161H231.406L233.71 20.2976H244.548L246.716 26.1161H253.219L241.974 0.406494ZM239.129 6.90098L242.652 15.8317H235.606L239.129 6.90098Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.419 1.75903H265.819L278.148 20.9736V1.75903H284.516V27.4686H276.252L263.516 8.66002L263.652 27.3333H257.419V1.75903Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.406494V28.8223L13.2774 12.0435L23.3032 23.0039L30.3484 15.9676L43.3548 32.8817V0.406494H0Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32.0693V41H6.23226L21.6774 24.2211L14.3613 19.3499L0 32.0693Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8387 41H43.3548V34.6402L33.0581 27.4686L10.8387 41Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.768 1.6245C287.632 1.21856 287.497 1.08325 287.226 1.08325C286.955 1.08325 286.819 1.21856 286.819 1.48919C286.819 2.03044 288.581 2.16575 288.581 3.38358C288.581 4.06014 288.039 4.46608 287.226 4.46608C286.548 4.46608 286.006 4.19546 285.871 3.38358L286.684 3.24826C286.819 3.78952 287.09 3.92483 287.361 3.92483C287.632 3.92483 287.903 3.78952 287.903 3.51889C287.903 2.84232 286.142 2.70701 286.142 1.6245C286.142 0.947933 286.548 0.541992 287.361 0.541992C288.039 0.541992 288.445 0.947933 288.716 1.48919L287.768 1.6245Z",
    fill: "#B7BCC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.781 0.406494L291.968 3.11276L291.155 0.406494H289.935V4.4659H290.748V1.21838L291.697 4.4659H292.239L293.187 1.21838V4.4659H294V0.406494H292.781Z",
    fill: "#B7BCC5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 294,
    height: 41.0001,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMagellanLogo);
export default __webpack_public_path__ + "static/media/dashboard-magellan-logo.21d791f5cee8e24424adf1dd2dae3809.svg";
export { ForwardRef as ReactComponent };